import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { usePoll } from 'shared/hooks/usePoll'

import { getBalanceFromBonusNotify } from 'features/notifies/actions'

const BalanceFromBonusPolling: React.FC = () => {
  const dispatch = useDispatch()

  const handleLoadBalanceFromBonus = useCallback(async () => {
    dispatch(getBalanceFromBonusNotify())
  }, [dispatch])

  usePoll(handleLoadBalanceFromBonus, { delay: 15 })

  return null
}

export default BalanceFromBonusPolling
